import script from "./SearchPendingPOSupp.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPendingPOSupp.vue?vue&type=script&setup=true&lang=js"

import "./SearchPendingPOSupp.vue?vue&type=style&index=0&id=2e2e6e4b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e2e6e4b"]])

export default __exports__